import { Auth } from "aws-amplify";
import Cookies from "js-cookie";
import Router from "next/router";
import { JS_TYPES } from "./Common";
import { SyntheticEvent } from "react";

export function diff<T extends Record<string, any>>(x: T, y: T): Partial<T> {
  const keys = [...Object.keys(x), ...Object.keys(y)];
  const result: Partial<T> = {};
  keys.forEach((key) => {
    if (JSON.stringify(y[key]) !== JSON.stringify(x[key])) {
      if (x[key] !== undefined) {
        result[key as keyof T] = x[key];
      }
    }
  });
  return result;
}

export function numberWithCommas(x: number | string | undefined): string {
  if (x === undefined) return "0";
  let str = x.toString();
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(str)) {
    str = str.replace(pattern, "$1,$2");
  }
  return str;
}

export function removeCognitoFromLocalStorage(): void {
  Object.keys(localStorage).forEach((key) => {
    if (key.includes("CognitoIdentityServiceProvider")) {
      localStorage.removeItem(key);
    }
  });
}

interface AuthContextType {
  setAuth: (user: { attributes: any }, authenticated: boolean) => void;
}

export const handleLogout = async (
  e?: SyntheticEvent,
  authContext?: any
): Promise<void> => {
  if (e && typeof e.preventDefault === JS_TYPES.FUNCTION) {
    e.preventDefault();
  }
  try {
    await Auth.signOut();
    Cookies.remove("authToken");
    removeCognitoFromLocalStorage();

    const cookies = Cookies.get();
    Object.keys(cookies).forEach((key) => {
      if (key.includes("CognitoIdentityServiceProvider")) {
        Cookies.remove(key);
      }
    });

    if (authContext) {
      authContext.setAuth({ attributes: {} }, false);
    }

    Router.replace("/", undefined, { shallow: false });
  } catch (err: any) {
    console.error(err.message);
  }
};
